exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-text-field--outline[data-v-4bc6937c] .v-input__control > .v-input__slot {\n  background: white !important;\n  border: 0;\n}\n.v-text-field--outline[data-v-4bc6937c]:not(.v-input--is-focused):not(.v-input--has-state) .v-input__control > .v-input__slot:hover {\n  border: 0;\n}\n", ""]);

// exports
